export default __webpack_public_path__ + "static/media/Slider-3_compressed.6c340004.jpg";